const SYMPTOM_CATEGORY = 'Symptom';
const DIAGNOSIS_CATEGORY = 'Diagnosis';

export { SYMPTOM_CATEGORY, DIAGNOSIS_CATEGORY };
